const ExpeditionIntroWindow = Prefab.createWindow(
    (page) => `${page.id}_introwindow`,
    "expeditionintrowindow_prefab_json"
);

ExpeditionIntroWindow.hasIntro = function (page) {
    const bundle = bundles[`${page.id}_introwindow`];
    return Boolean(bundle && bundle.frames.picture);
};
